import { render, staticRenderFns } from "./restaurant_settings.vue?vue&type=template&id=0fbfec54&scoped=true&"
import script from "./restaurant_settings.vue?vue&type=script&lang=js&"
export * from "./restaurant_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbfec54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbfec54')) {
      api.createRecord('0fbfec54', component.options)
    } else {
      api.reload('0fbfec54', component.options)
    }
    module.hot.accept("./restaurant_settings.vue?vue&type=template&id=0fbfec54&scoped=true&", function () {
      api.rerender('0fbfec54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/restaurant_settings.vue"
export default component.exports